module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./theme.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/theme.md
// module id = aLHV
// module chunks = 0